exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.error-template {padding: 40px 15px;text-align: center;\n}\n.error-actions {margin-top:15px;margin-bottom:15px;\n}\n.error-actions .btn { margin-right:10px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"optionsId":"0","vue":true,"scoped":false,"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/pages/errors/500.vue
// module id = WTSR
// module chunks = 54